document.addEventListener('DOMContentLoaded', function(){

    const el = document.querySelector('.typing-placeholder');

    if(!el) return;

    const words = [
        "Analog Digital Watches",
        "Digital Watches",
        'Automatic Watches',
        'Quartz',
        "Rolling Wheel"
    ];

    let wordIndex = 0;
    let charIndex = 0;
    let deleting = false;

    function type(){

        const word = words[wordIndex];

        if(!deleting){
            el.textContent = 'Search ' + word.substring(0, charIndex++);
            if(charIndex > word.length){
                deleting = true;
                setTimeout(type,1500);
                return;
            }
        }else{
            el.textContent = 'Search ' + word.substring(0, charIndex--);
            if(charIndex < 0){
                deleting = false;
                wordIndex = (wordIndex + 1) % words.length;
            }
        }

        setTimeout(type, deleting ? 50 : 100);
    }

    type();
});